export default function deepClonePlainObject<T>(object: T): T {
  return JSON.parse(JSON.stringify(object));
}
